import React, { useCallback, useEffect, useState, useContext } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import Card from 'components/inputs/Card';
import SessionHeading from 'components/general/SessionHeading';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Select from 'components/inputs/Select';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import { Formik, Form, FieldArray } from 'formik';
import { CREATE_CHARGER, UPDATE_CHARGER, GET_CHARGER } from 'actions/charger';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { FETCH_CHARGING_STATION } from 'actions/chargingStation';
import { FETCH_OEM } from 'actions/oem';
import { FETCH_TARIFF } from 'actions/tariff';
import CheckBox from 'components/inputs/CheckBox';
import { FETCH_CHARGE_SPEED } from 'actions/chargeSpeed';
import { FETCH_OEM_VENDOR } from 'actions/oemVendor';
import DatePickerInput from 'components/inputs/DatePickerInput';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import Footer from 'components/general/Footer';
import { GET_ADD_ONS, GET_STATION_CHARGERS, MANAGE_ADD_ONS, MANAGE_STATION_CHARGERS, UPDATE_STATUS_CODE } from 'components/common/constant';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { FETCH_OWNERSHIP_TYPE } from 'actions/ownershipType';

const ChargerForm = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { chargerId } = useParams();
  const { navigateTo } = useContext(NavContext);
  const queryParams = new URLSearchParams(window.location.search);
  const chargingStationId = queryParams.get('station');

  const allStations = useSelector((state) => state.chargingStation.chargingStations);
  const allOems = useSelector((state) => state.oem.oems);
  const ownershipTypeList = useSelector((state) => state.ownershipType.ownershipTypes);
  const allOemVendor = useSelector((state) => state.oemVendor.oemVendors);
  const allChargerSpeed = useSelector((state) => state.chargeSpeed.chargeSpeed);
  // const isLoading = useSelector((state) => state.charger.isLoading);
  const chargerDetail = useSelector((state) => state.charger.chargerDetails);
  const allTariffList = useSelector((state) => state.tariff.tariff);
  const profileDetail = useSelector((state) => state.profile.userProfile);
  const tenantId = _.get(profileDetail, 'tenant.id', '');
  const currentUserName = _.get(profileDetail, 'name', '');
  const supportApp = _.get(profileDetail, 'tenant.support_cz_app_booking', '');
  const oemPage = useSelector((state) => state.oemVendor.page);
  const tariffPage = useSelector((state) => state.tariff.page);
  const ownershipTypePage = useSelector((state) => state.ownershipType.page);
  const oemTotalPage = useSelector((state) => state.oemVendor.totalPages);
  const tariffTotalPage = useSelector((state) => state.tariff.totalPages);
  const ownershipTypeTotalPage = useSelector((state) => state.ownershipType.totalPages);
  // const [generateChargerId, setGenerateChargerId] = useState('');
  const [isDraft, setDraft] = useState(false);

  const maintenanceTypes = [
    { label: 'Charger Breakdown', value: 'Charger Breakdown' },
    { label: 'Station Electrical Breakdown', value: 'Station Electrical Breakdown' },
    { label: 'Preventive Maintenance', value: 'Preventive Maintenance' },
    { label: 'Non-Operational', value: 'Non-Operational' },
  ];

  const editChargerDetail = useCallback(
    (data) =>
      dispatch({
        type: UPDATE_CHARGER.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
            setTimeout(() => {
              navigateTo(`/charger/${chargerId}`);
            }, 1000);
          }
        },
      }),
    [chargerId]
  );
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);

  const getChargerDetail = useCallback((id) => {
    dispatch({ type: GET_CHARGER.REQUEST, payload: id });
  }, []);

  const getAllChargerSpeed = useCallback(() => dispatch({ type: FETCH_CHARGE_SPEED.REQUEST }), []);

  const getChargeSpotByOem = useCallback((id = '') => {
    dispatch({ type: FETCH_OEM.REQUEST, payload: { vendor: id, limit: 999 } });
  }, []);

  const getTariffByChargeSpot = useCallback((data = {}) => {
    dispatch({ type: FETCH_TARIFF.REQUEST, payload: data });
  }, []);

  const getChargingStations = useCallback(() => {
    const data = {
      request_all: true,
    };
    dispatch({ type: FETCH_CHARGING_STATION.REQUEST, payload: data });
  }, []);

  const getOemVendor = useCallback((data = {}) => {
    dispatch({ type: FETCH_OEM_VENDOR.REQUEST, payload: data });
  }, []);

  const getOwnershipType = useCallback((data = {}) => {
    dispatch({ type: FETCH_OWNERSHIP_TYPE.REQUEST, payload: data });
  }, []);

  const getAddOns =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_ADD_ONS),
      (data) => data.name
    );

  const manageAddOns =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_ADD_ONS),
      (data) => data.name
    );

  const manageStationCharger =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_STATION_CHARGERS),
      (data) => data.name
    );

  const getStationCharger =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_STATION_CHARGERS),
      (data) => data.name
    );

  useEffect(() => {
    getOemVendor({ limit: 999 });
    getAllChargerSpeed();
    getChargingStations();
    getOwnershipType({ limit: 999 });
  }, []);

  useEffect(() => {
    if (chargerId) {
      getChargerDetail(chargerId);
    }
    if (chargerId && !_.isEmpty(chargerDetail)) {
      getChargeSpotByOem(_.get(chargerDetail, 'oem.vendor.id'));
      getTariffByChargeSpot({ oem: _.get(chargerDetail, 'oem.id'), limit: 999 });
    }
  }, [chargerId, _.isEmpty(chargerDetail) && chargerDetail]);

  const ChargerSchema = Yup.object({
    charger_id: Yup.string().required(t('chargerForm.chargerId')).strict(true).trim(t('chargerForm.space')),
    oem_vendor: Yup.string().required(t('chargerForm.oemVendor')),
    oem: Yup.string().required(t('chargerForm.oem')),
    charging_station: Yup.string().required(t('chargerForm.chargingStation')).strict(true).trim(t('chargerForm.space')),
    tariff: Yup.string().required(t('chargerForm.tariff')),
    serial_number: Yup.string(),
    charging_speed: Yup.string().required(t('chargerForm.chargingSpeed')),
    custom_rating: Yup.number().nullable().positive('Custom Rating must be a positive number').typeError('Custom Rating must be a number'),
    maintenance_type: Yup.string().when('operational_status', {
      is: 'UnderMaintenance',
      then: Yup.string().required('Maintenance type is required when operational status is Under Maintenance'),
      otherwise: Yup.string().nullable(),
    }),
    maintenance_remarks: Yup.string().when('operational_status', {
      is: 'UnderMaintenance',
      then: Yup.string().required('Maintenance remarks is required when operational status is Under Maintenance'),
      otherwise: Yup.string().nullable(),
    }),
  });
  const initialValues = chargerId
    ? {
      ...chargerDetail,
      charging_station: _.get(chargerDetail, 'charging_station.id', ''),
      oem: _.get(chargerDetail, 'oem.id', ''),
      oem_vendor: _.get(chargerDetail, 'oem.vendor.id', ''),
      tariff: _.get(chargerDetail, 'tarrif.id', ''),
      charger_id: _.get(chargerDetail, 'charger_id', ''),
      installation_date: chargerDetail.installation_date ? moment(_.get(chargerDetail, 'installation_date')).format('YYYY-MM-DD') : '',
      go_live_date: chargerDetail.go_live_date ? moment(_.get(chargerDetail, 'go_live_date')).format('YYYY-MM-DD') : '',
      ownership_type: _.get(chargerDetail, 'ownership_type', ''),
      charger_status: _.get(chargerDetail, 'charger_status', ''),
      operational_status: _.get(chargerDetail, 'operational_status', 'Active'), // Ensure operational_status is included
      maintenance_type: _.get(chargerDetail, 'maintenance_type', ''),
      maintenance_remarks: _.get(chargerDetail, 'maintenance_remarks', ''),
      plugs: _.map(_.get(chargerDetail, 'plugs', []), (item) => {
        return {
          ...item,
          name: _.get(item, 'name'),
          connector_id: _.get(item, 'connector_id'),
          tarrif: _.get(item, 'tarrif.id'),
        };
      }),
      charging_speed: _.get(chargerDetail, 'charging_speed', ''),
      custom_rating: _.get(chargerDetail, 'custom_rating', ''),
    }
    : {
      description: '',
      charger_id: '',
      oem: '',
      plugs: [],
      is_active: true,
      tenant: '',
      installation_date: '',
      charging_station: chargingStationId ? _.get(_.find(allStations, { id: chargingStationId }), 'id', '') : '',
      timing_type: 'custom',
      parking_restrictions: false,
      is_superfast_mode_supported: false,
      is_duplicate_transaction_mode_supported: false,
      is_ping_pong_supported: false,
      auto_charge_supported: false,
      otp_verification: false,
      rfid_verification: false,
      wss_supported: false,
      is_chargecoin_disabled: _.get(_.find(allStations, { id: chargingStationId }), 'is_chargecoin_disabled', ''),
      comments: '',
      cooldown_time: '',
      charger_status: '',
      charging_speed: '',
      oem_vendor: '',
      tariff: '',
      serial_number: '',
      load_limit: '',
      maintenance_type: '',
      maintenance_remarks: '',
      settings: {
        ocpp_details: {},
        current_firmware: '1.1',
      },
      custom_rating: '',
    };

  const addCharger = useCallback((data) => {
    dispatch({
      type: CREATE_CHARGER.REQUEST,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          if (chargingStationId) {
            setTimeout(() => {
              navigateTo(`/stations/${chargingStationId}`);
            }, 1000);
          } else {
            setTimeout(() => {
              navigateTo('/stations');
            }, 1000);
          }
        }
      },
    });
  }, []);

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title={`${chargerId ? 'Edit' : 'Add'} ${t('header.charger')}`} />
        <div className="page-content-wrapper scrollable">
          <div className="add-charger-page__main">
            <Card className="charger-form--card">
              <Formik
                enableReinitialize={!!chargerId}
                initialValues={initialValues}
                validationSchema={ChargerSchema}
                onSubmit={(values, { setSubmitting }) => {
                  values['is_active'] = !isDraft;
                  if (values.custom_rating === '') {
                    values.custom_rating = null;
                  } else if (values.custom_rating !== null) {
                    values.custom_rating = Number(values.custom_rating);
                  }
                  if (values.operational_status === 'ComingSoon') {
                    values['charger_status'] = 'Unavailable';
                    values['operational_status'] = 'ComingSoon';
                  } else if (values.operational_status === 'UnderMaintenance') {
                    values['operational_status'] = 'UnderMaintenance';
                  } else {
                    values['operational_status'] = 'Active';
                  }
                  const uniqId = values.charger_id;
                  if (chargerId) {
                    const editedChargerData = {
                      ...values,
                      chargerId: chargerId || values.id,
                      id: uniqId,
                      timings: _.map(values.timings, (item) => _.omit(item, ['_id'])),
                      plugs: _.map(values.plugs, (item) => _.omit(item, ['oem_ref'])),
                      tarrif: values.tariff,
                    };
                    const newData = _.omit(editedChargerData, [
                      'settings',
                      'timings',
                      'timings',
                      'id',
                      'is_errored',
                      'old_status',
                      'is_auth_supported',
                      'oem_vendor',
                      'tariff',
                      'ocpp_url',
                      'last_active',
                      'tenant',
                      'createdAt',
                      'updatedAt',
                      'times_sent_trigger',
                      'is_external_charger',
                      'external_evse_id',
                      'ocpiCredential',
                      'is_auto_charge_supported',
                      'last_session_happened',
                      'region',
                      'lastStatusUpdatedAt',
                      'external_evse_images',
                    ]);
                    if (values.operational_id) {
                      editedChargerData.operational_status = values.operational_status;
                    }
                    editChargerDetail(newData);
                  } else {
                    const chargerDetail = {
                      ...values,
                      tarrif: values.tariff,
                      plugs: _.map(values.plugs, (item) => _.omit(item, ['_id', 'errorCode', 'errorMessage', 'external_tarrif', 'oem_ref'])),
                    };
                    const addChargerData = _.omit(chargerDetail, ['tariff', 'oem_vendor']);
                    addCharger({ ...addChargerData, tenant: tenantId });
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, handleSubmit, handleChange, setFieldValue, isSubmitting, errors, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <div>
                      <SessionHeading text={t('addChargerForm.chargerInformation')} />
                      <div className="charger-form--block">
                        <Row>
                          <Col lg={12}>
                            <Select
                              isRequired
                              label={t('addChargerForm.stationSituated')}
                              options={_.map(allStations, (station) => {
                                return { label: station.name, value: station.id };
                              })}
                              placeholder={t('placeHolder.selectStation')}
                              name="charging_station"
                              value={values.charging_station}
                              onChange={(val) => setFieldValue(`charging_station`, val)}
                              error={errors.charging_station && touched.charging_station ? errors.charging_station : null}
                            />
                          </Col>
                          <Col lg={6} md={6}>
                            <TextInput
                              as="textarea"
                              rows="4"
                              inputClass="scrollable"
                              placeholder={t('placeHolder.selectDescription')}
                              label={t('addChargerForm.description')}
                              name="description"
                              value={values.description}
                              onChange={handleChange}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <div className="parking-checkbox-input__block">
                              <label htmlFor="parking_restriction" className="parking--label">
                                {t('addChargerForm.parkingRestrictions')}
                              </label>
                              <CheckBox
                                name="parking_restriction"
                                checked={values.parking_restrictions}
                                onChange={(e) => setFieldValue('parking_restrictions', e.target.checked)}
                              />
                              <br />
                              <label htmlFor="superfast_mode_supported" className="parking--label">
                                {t('addChargerForm.superFastMode')}
                              </label>
                              <CheckBox
                                name="superfast_mode_supported"
                                checked={values.is_superfast_mode_supported}
                                onChange={(e) => setFieldValue('is_superfast_mode_supported', e.target.checked)}
                              />
                              <br />
                              <label htmlFor="duplicate_transaction_mode_supported" className="parking--label">
                                {t('addChargerForm.duplicateTransactionMode')}
                              </label>
                              <CheckBox
                                name="duplicate_transaction_mode_supported"
                                checked={values.is_duplicate_transaction_mode_supported}
                                onChange={(e) => setFieldValue('is_duplicate_transaction_mode_supported', e.target.checked)}
                              />
                              <br />
                              <label htmlFor="auto_charge_supported" className="parking--label">
                                {t('addChargerForm.autoChargingSupport')}
                              </label>
                              <CheckBox
                                name="auto_charge_supported"
                                checked={values.auto_charge_supported}
                                onChange={(e) => setFieldValue('auto_charge_supported', e.target.checked)}
                              />
                              <br />
                              <label htmlFor="ping_pong_supported" className="parking--label">
                                {t('addChargerForm.pingPongSupported')}
                              </label>
                              <CheckBox
                                name="ping_pong_supported"
                                checked={values.is_ping_pong_supported}
                                onChange={(e) => setFieldValue('is_ping_pong_supported', e.target.checked)}
                              />
                              <div className="otp-checkbox">
                                <label htmlFor="otp_verification" className="parking--label">
                                  {t('addChargerForm.otp')}
                                </label>
                                <CheckBox
                                  name="otp_verification"
                                  checked={values.otp_verification}
                                  onChange={(e) => setFieldValue('otp_verification', e.target.checked)}
                                />
                                <br />
                                <label htmlFor="rfid_verification" className="parking--label">
                                  {t('addChargerForm.rifd')}
                                </label>
                                <CheckBox
                                  name="rfid_verification"
                                  checked={values.rfid_verification}
                                  onChange={(e) => setFieldValue('rfid_verification', e.target.checked)}
                                />
                              </div>
                              <label htmlFor="wss_supported" className="parking--label">
                                {t('addChargerForm.wssSupported')}
                              </label>
                              <CheckBox
                                name="wss_supported"
                                checked={values.wss_supported}
                                onChange={(e) => setFieldValue('wss_supported', e.target.checked)}
                              />
                              <br />
                              <label htmlFor="load_balancing" className="parking--label">
                                {t('addChargerForm.loadBalancing')}
                              </label>
                              <CheckBox
                                name="load_balancing"
                                checked={values.does_support_load_balancing}
                                onChange={(e) => setFieldValue('does_support_load_balancing', e.target.checked)}
                              />
                              <br />
                            </div>
                          </Col>
                          <Col lg={6} md={6}>
                            <TextInput
                              isRequired
                              label={t('addChargerForm.chargerID')}
                              name="charger_id"
                              value={values.charger_id}
                              onChange={handleChange}
                              error={errors.charger_id && touched.charger_id ? errors.charger_id : null}
                            />
                          </Col>
                          <Col lg={6} md={6}>
                            <TextInput
                              post_text={t('addChargerForm.mins')}
                              label={t('addChargerForm.cooldownTime')}
                              name="cooldown_time"
                              value={values.cooldown_time}
                              onChange={handleChange}
                            />
                          </Col>
                          <Col lg={6} md={6}>
                            <Row>
                              <Col lg={12} md={12}>
                                <Select
                                  isRequired
                                  label={t('addChargerForm.oem')}
                                  options={_.map(allOemVendor, (oemItem) => {
                                    return { label: oemItem.name, value: oemItem.id };
                                  })}
                                  placeholder={t('placeHolder.selectOEMName')}
                                  name="oem_vendor"
                                  value={values.oem_vendor}
                                  onMenuScrollDown={true}
                                  getDataOnScrollDown={getOemVendor}
                                  page={oemPage}
                                  totalPage={oemTotalPage}
                                  onChange={(val) => {
                                    getChargeSpotByOem(val);
                                    setFieldValue(`oem_vendor`, val);
                                    setFieldValue(`oem`, '');
                                    setFieldValue(`tariff`, '');
                                    setFieldValue(`plugs`, []);
                                  }}
                                  error={errors.oem_vendor && touched.oem_vendor ? errors.oem_vendor : null}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={6} md={6}>
                            <Row>
                              <Col lg={12} md={12}>
                                <Select
                                  isRequired
                                  label={t('addChargerForm.chargespotName')}
                                  options={_.map(allOems, (item) => {
                                    return { label: item.name, value: item.id };
                                  })}
                                  placeholder={t('placeHolder.selectChargeSport')}
                                  name="oem"
                                  value={values.oem}
                                  onChange={(val) => {
                                    setFieldValue(`oem`, val);
                                    setFieldValue(`tariff`, '');
                                    getTariffByChargeSpot({ oem: val, limit: 999 });
                                    const oemPlugs = _.get(_.find(allOems, { id: val }), 'plugs');
                                    if (_.isEmpty(oemPlugs)) {
                                      setFieldValue('plugs', []);
                                    } else {
                                      const plugData = _.map(oemPlugs, (item) => {
                                        return { name: item.name, connector_id: item.number, oem_ref: item._id, status: 'Unavailable' };
                                      });
                                      setFieldValue('plugs', plugData);
                                    }
                                  }}
                                  error={errors.oem && touched.oem ? errors.oem : null}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              label={t('addChargerForm.tariff')}
                              options={_.map(allTariffList, (item) => {
                                return { label: item.name, value: item.id };
                              })}
                              placeholder={t('placeHolder.selectTarrif')}
                              name="tarrif"
                              value={values.tariff}
                              onMenuScrollDown={true}
                              getDataOnScrollDown={(data) => getTariffByChargeSpot({ ...data, oem: values.oem })}
                              page={tariffPage}
                              totalPage={tariffTotalPage}
                              onChange={(val) => {
                                setFieldValue(`tariff`, val);
                              }}
                              error={errors.tariff && touched.tariff ? errors.tariff : null}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              label={t('addChargerForm.operationalStatus')}
                              options={[
                                { label: 'Active', value: 'Active' },
                                { label: 'UnderMaintenance', value: 'UnderMaintenance' },
                                { label: 'Coming Soon', value: 'ComingSoon' },
                              ]}
                              placeholder={t('placeHolder.operationalStatus')}
                              name="operational_status"
                              value={values.operational_status}
                              onChange={(val) => {
                                setFieldValue('operational_status', val);
                                if (val !== 'UnderMaintenance') {
                                  setFieldValue('maintenance_type', '');
                                  setFieldValue('maintenance_remarks', '');
                                }
                              }}
                              error={errors.operational_status && touched.operational_status ? errors.operational_status : null}
                            />
                          </Col>
                          {(values.operational_status === 'UnderMaintenance' || values.operational_status === 'Under Maintenance') && (
                            <Col lg={6} md={12}>
                              <Select
                                isRequired
                                label="Maintenance Type"
                                options={maintenanceTypes}
                                placeholder="Select Maintenance Type"
                                name="maintenance_type"
                                value={values.maintenance_type || ''}
                                onChange={(val) => setFieldValue('maintenance_type', val)}
                                error={errors.maintenance_type && touched.maintenance_type ? errors.maintenance_type : null}
                              />
                            </Col>
                          )}
                          {(values.operational_status === 'UnderMaintenance' || values.operational_status === 'Under Maintenance') && (
                            <Col lg={6} md={12}>
                              <TextInput
                                isRequired
                                as="textarea"
                                rows="4"
                                inputClass="scrollable"
                                placeholder="Maintenance Remarks"
                                label="Maintenance Remarks"
                                name="maintenance_remarks"
                                value={values.maintenance_remarks}
                                onChange={handleChange}
                                error={errors.maintenance_remarks && touched.maintenance_remarks ? errors.maintenance_remarks : null}
                              />
                            </Col>
                          )}
                          <Col lg={6} md={6}>
                            <Select
                              isRequired
                              label={t('addChargerForm.chargingSpeed')}
                              options={_.map(allChargerSpeed, (item) => {
                                return { label: item.name, value: item.id };
                              })}
                              placeholder={t('placeHolder.selectSpeed')}
                              name="charging_speed"
                              value={values.charging_speed}
                              onChange={(val) => setFieldValue(`charging_speed`, val)}
                              error={errors.charging_speed && touched.charging_speed ? errors.charging_speed : null}
                            />
                          </Col>
                          <Col lg={6} md={6}>
                            <DatePickerInput
                              placeholder={t('placeHolder.selectInstallDate')}
                              label={t('addChargerForm.installationDate')}
                              name="installation_date"
                              value={_.get(values, 'installation_date') || ''}
                              onChange={(dateString) => setFieldValue('installation_date', dateString)}
                            />
                          </Col>
                          <Col lg={6} md={6}>
                            <TextInput
                              label={t('addChargerForm.serialNumber')}
                              name="serial_number"
                              value={values.serial_number}
                              onChange={handleChange}
                            />
                          </Col>
                          <Col lg={6} md={6}>
                            <TextInput label={t('addChargerForm.loadLimit')} name="load_limit" value={values.load_limit} onChange={handleChange} />
                          </Col>
                          <Col lg={6} md={6}>
                            <TextInput
                              type="number"
                              step="any"
                              label="Custom Rating (kWh)"
                              name="custom_rating"
                              value={values.custom_rating}
                              onChange={handleChange}
                              error={errors.custom_rating && touched.custom_rating ? errors.custom_rating : null}
                            />
                          </Col>
                          {supportApp ? (
                            <Col>
                              <div className="parking-checkbox-input__block">
                                <label htmlFor="is_chargecoin_disabled" className="parking--label">
                                  {t('addChargerForm.isDisableChargecoin')}
                                </label>
                                <CheckBox
                                  name="is_chargecoin_disabled"
                                  checked={values.is_chargecoin_disabled}
                                  onChange={(e) => setFieldValue('is_chargecoin_disabled', e.target.checked)}
                                />
                              </div>
                            </Col>
                          ) : (
                            ''
                          )}
                          <Col lg={6} md={6}>
                            <DatePickerInput
                              placeholder={t('placeHolder.goLiveDate')}
                              label={t('addChargerForm.goLiveDate')}
                              name="go_live_date"
                              value={_.get(values, 'go_live_date') || ''}
                              onChange={(dateString) => setFieldValue('go_live_date', dateString)}
                            />
                          </Col>
                          <Col lg={6} md={6}>
                            <Select
                              label={t('addChargerForm.ownershipType')}
                              options={_.map(ownershipTypeList, (item) => {
                                return { label: item.name, value: item.name };
                              })}
                              placeholder={t('placeHolder.ownershipType')}
                              name="ownership_type"
                              value={values.ownership_type}
                              onMenuScrollDown={true}
                              getDataOnScrollDown={getOwnershipType}
                              page={ownershipTypePage}
                              totalPage={ownershipTypeTotalPage}
                              onChange={(val) => {
                                setFieldValue(`ownership_type`, val);
                              }}
                              error={errors.ownership_type && touched.ownership_type ? errors.ownership_type : null}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                    <div>
                      <SessionHeading text={t('addChargerForm.plugsInformation')} />
                      <div className="charger-form--block">
                        <div className="plug-block__field-inputs">
                          <FieldArray
                            name="plugs"
                            render={() => (
                              <>
                                {_.map(values.plugs, (field, index) => (
                                  <div className="charger-plug--item">
                                    <Row key={`charger-plug-${index}`}>
                                      <Col lg={4} md={6}>
                                        <TextInput
                                          disabled
                                          label={t('addChargerForm.name')}
                                          name="name"
                                          value={field.name || ''}
                                          onChange={(e) => setFieldValue(`plugs[${index}].name`, e.target.value)}
                                        />
                                      </Col>
                                      <Col lg={4} md={6}>
                                        <TextInput
                                          disabled
                                          label={t('addChargerForm.connectorId')}
                                          name="connector_id"
                                          value={field.connector_id || ''}
                                          onChange={(e) => setFieldValue(`plugs[${index}].connector_id`, e.target.value)}
                                        />
                                      </Col>
                                      <Col lg={4} md={12}>
                                        <Select
                                          isClearable
                                          label={t('addChargerForm.tariff')}
                                          options={_.map(allTariffList, (item) => {
                                            return { label: item.name, value: item.id };
                                          })}
                                          placeholder={t('placeHolder.selectTarrif')}
                                          name="tarrif"
                                          value={field.tarrif || ''}
                                          onMenuScrollDown={true}
                                          getDataOnScrollDown={(data) => getTariffByChargeSpot({ ...data, oem: values.oem })}
                                          page={tariffPage}
                                          totalPage={tariffTotalPage}
                                          onChange={(val) => {
                                            setFieldValue(`plugs[${index}].tarrif`, val);
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                ))}
                              </>
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <SessionHeading text={t('addChargerForm.comments/Notes')} />
                      <div className="charger-form--block">
                        <Row>
                          <Col>
                            <TextInput
                              as="textarea"
                              rows="6"
                              inputClass="scrollable"
                              label={t('addChargerForm.commentsforChargingStation')}
                              name="comments"
                              value={values.comments}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                    {!_.isEmpty(manageAddOns) ||
                      (!_.isEmpty(getAddOns) && !_.isEmpty(manageAddOns)) ||
                      !_.isEmpty(manageStationCharger) ||
                      (!_.isEmpty(getStationCharger) && !_.isEmpty(manageStationCharger)) ? (
                      <div className="save-draft-btn--block">
                        <Button type="submit" className="save-btn draft--btn" disabled={isSubmitting} onClick={() => setDraft(true)}>
                          {t('button.saveDraft')}
                        </Button>
                        <Button type="submit" className="save-btn" disabled={isSubmitting} onClick={() => setDraft(false)}>
                          {t('button.savePublish')}
                        </Button>
                      </div>
                    ) : (
                      <div className="save-draft-btn--block">
                        <Button className="save-btn draft--btn"> {t('button.saveDraft')}</Button>
                        <Button className="save-btn"> {t('button.savePublish')}</Button>
                      </div>
                    )}
                  </Form>
                )}
              </Formik>
            </Card>
          </div>
          {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
        </div>
      </LayoutContainer>
    </React.Fragment>
  );
};

export default ChargerForm;
